import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { api } from "../lib/api";

const Icon = ({ name, ...props }) => {
  const Comp = Icons[name] || Icons.Sparkles;
  return <Comp {...props} />;
};

export default function ProjectsBento({ limit }) {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => {});
  }, []);

  const shown = limit ? projects.slice(0, limit) : projects;

  return (
    <section
      id="projetos"
      data-testid="projects-section"
      className="py-24 md:py-32 bg-white border-t border-neutral-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-14 items-end">
          <div className="lg:col-span-7">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#003F88] font-semibold">
              <span className="accent-line" />
              Projetos para Lauro de Freitas
            </div>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight mt-6 text-neutral-900">
              17 áreas, <em className="italic font-light">um único compromisso</em>: a sua cidade.
            </h2>
          </div>
          <p className="lg:col-span-5 text-base md:text-lg leading-relaxed text-neutral-600 font-light">
            Da saúde à acessibilidade, da causa animal ao urbanismo — cada eixo reúne leis aprovadas,
            indicações e conquistas reais para Lauro de Freitas.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-px bg-neutral-200">
          {shown.map((p, idx) => (
            <Link
              key={p.id}
              to={`/projetos#${p.id}`}
              data-testid={`project-card-${p.id}`}
              className="bento-card bg-white p-8 md:p-10 flex flex-col justify-between min-h-[260px] reveal"
              style={{ animationDelay: `${idx * 0.05}s` }}
            >
              <div>
                <Icon name={p.icon} size={28} className="bento-icon text-[#003F88]" strokeWidth={1.5} />
                <div className="mt-6 text-[10px] uppercase tracking-[0.22em] opacity-70">
                  {p.area}
                </div>
                <h3 className="font-serif-display text-2xl md:text-[28px] font-medium leading-tight mt-2">
                  {p.title}
                </h3>
              </div>
              <div className="mt-8 flex items-center justify-between text-xs uppercase tracking-widest">
                <span>Ver mais</span>
                <Icons.ArrowUpRight size={18} className="bento-arrow" />
              </div>
            </Link>
          ))}
        </div>

        {limit && (
          <div className="mt-12 text-center">
            <Link
              to="/projetos"
              data-testid="projects-cta-all"
              className="inline-flex items-center gap-3 border-2 border-[#003F88] text-[#003F88] px-8 py-4 text-xs uppercase tracking-[0.2em] font-medium hover:bg-[#003F88] hover:text-white transition-colors"
            >
              Ver todas as áreas
              <Icons.ArrowRight size={16} />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
